import React from "react";
import PropTypes from "prop-types";

import "./css/index.scss";

const Breadcrumb = ({ elements }) => (
  <nav aria-label="breadcrumb">
    <ol className="breadcrumb">
      {elements.map(({ name, action, active }) => (
        <li className={`breadcrumb-item ${active ? "active" : ""}`}>
          {action ? (
            <button type="button" onClick={action}>
              {name}
            </button>
          ) : (
            <span>{name}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

Breadcrumb.propTypes = {
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      action: PropTypes.func,
      active: PropTypes.bool,
      clickable: PropTypes.bool
    })
  ).isRequired
};

export default Breadcrumb;
